import { Box, Divider, Typography } from '@mui/material'
import React, { memo } from 'react'
import InputField from '../forms/InputField'

const EssayLength = memo(({ dataQuestion, indices, form }) => {
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'} mx={'-1rem'}>
      <Box
        bgcolor={'#9AA5EA'}
        width={'100%'}
        sx={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <Divider
          sx={{
            backgroundColor: 'white',
            height: '3px',
          }}
        />
        <Box px={2} py={3}>
          <Typography
            textAlign={'justify'}
            fontWeight={500}
            fontSize={'14px'}
            color={'white'}
            letterSpacing={1.2}
            lineHeight={1.7}
            sx={{
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
            }}
          >
            {dataQuestion.soal}
          </Typography>
        </Box>
      </Box>
      <Box height={'100%'} pt={5} px={1}>
        <InputField
          control={form.control}
          name={`question_${indices}`}
          errors={form.formState.errors}
          type="number"
          label={`Pilihan 1 dari ${dataQuestion.esai_length}`}
          placeholder={'Ketik range angka'}
          maxNumber={dataQuestion.esai_length}
        />
      </Box>
    </Box>
  )
}, arePropEqual)

function arePropEqual(oldProps, newProps) {
  return oldProps.indices !== newProps.indices
}
export default EssayLength
